export default "__VITE_ASSET__DDC9C_Fw__"